@use '@lib/assets/styles/main.scss' as *;

.root {
  height: 100%;
  min-height: 100vh;
  min-height: 100svh;
  @include responsive($md1) {
    display: flex;
    align-items: center;
    justify-content: center;
    background: url('@lib/assets/images/technical-pause-bg.jpeg') $gray100 no-repeat top center / cover;
    padding: 40px;
    & > * {
      width: 100%;
      max-width: 944px;
    }
  }
}

.whiteBox {
  text-align: center;
  border-radius: 20px;
  background: $gray0;
  padding: 40px 16px;
}

.logo {
  display: block;
  width: 112px;
  height: auto;
  margin: 0 auto 64px;
}

.title {
  margin-bottom: 24px;
}

.text {
  margin-bottom: 32px;
  color: $gray500;
}

.subTitle {
  margin-bottom: 16px;
}

.line {
  background-color: $gray100;
  display: block;
  height: 1px;
  margin: 40px -16px;
}

.contactUsText {
  color: $gray500;
  display: block;
}

.contactUsLink {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.contactUsLinkIcon {
  color: $blue500;
}

.countdown {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, auto));
  @include responsive($md1) {
    grid-gap: 24px;
  }
  @include responsive($xs2, $md1) {
    grid-gap: 16px;
  }
  @include responsive(null, $xs2) {
    grid-gap: 12px;
  }
}

.countdownSection {
  display: flex;
  align-items: center;
  justify-content: center;
}

.countdownDigits {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 4px;
}

.countdownDigit {
  border-radius: 8px;
  background: $blue20;
  @include responsive($md1) {
    width: 48px;
    height: 64px;
    line-height: 64px;
  }
  @include responsive(null, $md1) {
    width: 32px;
    height: 50px;
    line-height: 50px;
  }
}

.countdownLabel {
  color: $gray500;
}
